module.exports = __webpack_public_path__ + "static/poster-cooking-channel-b8f872823c5c50a3b5d1c22ad5cf1651.jpg";